import angular from 'angular';

class modalContainerDisableCtrl {
  /* @ngInject */
  constructor() {}

  $onInit() {
    this.containersSelected = angular.copy(this.resolve.containersSelected);
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  ok() {
    this.modalInstance.close(this.containersSelected);
  }
}

angular.module('app.principal').component('modalContainerDisable', {
  templateUrl: require('./modal-container-disable.html'),
  controller: modalContainerDisableCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
